import './LayerReport.css'

import React from 'react'

import { withStyles } from '@material-ui/core/styles'
import get from 'lodash/get'
import includes from 'lodash/includes'
import isNumber from 'lodash/isNumber'
import remove from 'lodash/remove'
import toLower from 'lodash/toLower'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'

import * as Model from 'api/model'
import { ICON_COLOR_DISABLED, ICON_COLOR_ENABLED, PANEL_TITLE_REPORT } from 'drawer/tabs/layers/panels/LayerPanels'
import LayerPanelsExpansion from 'drawer/tabs/layers/panels/LayerPanelsExpansion'
import Upgrade from 'drawer/tabs/Upgrade'

import IconReport from './IconReport'
import LayerReportPropSelect from './LayerReportPropSelect'

const styles = theme => ({
  root: {
    paddingLeft: 20,
    paddingRight: 20
  },
  notLicensed: {}
})

class Report extends React.Component {
  component = this

  constructor (props) {
    super(props)
    const { titleid, layer } = this.props
    this.selectValues = []
    this.dataPath = `app.config.layerbytitleid[${titleid}].data`
    this.isLicensed = Model.get('config.layout.drawer.tabs.layers.report.enabled', true)
    this.isVisible = Model.get('config.layout.drawer.tabs.layers.report.visible', true)
    this.isValidLayerType = toLower(layer.type) === 'geojson'

    this.pure = {}
    this.pure.upgradeText = 'Upgrade Pozi to enable layer report.'
    this.pure.upgradeURL = Model.get('config.layout.drawer.tabs.tools.selectgroup.upgrade.url', '')
    this.pure.upgradeURLLabel = Model.get('config.layout.drawer.tabs.tools.selectgroup.upgrade.urlLabel', 'Learn More')
    this.pure.upgradeMarkup = <Upgrade text={this.pure.upgradeText} url={this.pure.upgradeURL} urlLabel={this.pure.upgradeURLLabel} />
  }

  getSelectValues (geojson) {
    const { layer } = this.props
    if (this.selectValues.length > 0) {
      return this.selectValues
    } else {
      let selectValues = []
      const featureProperties = Object.assign({}, get(geojson, 'features[0].properties', {}))
      if (featureProperties) {
        // Remove number fields from grouping list.
        for (const key in featureProperties) {
          const val = featureProperties[key]
          if (isNumber(val)) {
            delete featureProperties[key]
          }
        }
        selectValues = Object.keys(featureProperties)
        // Only show filters in the include array
        if ((this.isLicensed && layer && layer.type === 'GeoJSON') || (layer && layer.propsFilter && layer.propsFilter.include)) {
          if (layer.propsFilter && layer.propsFilter.include) {
            layer.reportFilter = true // Flag to say some filter was applied.
            remove(selectValues, function (value) {
              return !includes(layer.propsFilter.include, value)
            })
          }
        }
      }
      return selectValues
    }
  }

  render () {
    const { classes, titleid } = this.props

    if (!this.isVisible || !this.isValidLayerType) {
      console.log('render - layer not visible or layer type is not valid', titleid, this.isVisible, this.isValidLayerType)
      return null
    }

    const geojson = Model.get(this.dataPath, null)
    this.selectValues = this.getSelectValues(geojson)

    let icon = ''
    let markup = ''

    if (!this.isLicensed) {
      icon = <IconReport htmlColor={ICON_COLOR_DISABLED} />
      markup = (
        <div className={classes.root}>
          {this.pure.upgradeMarkup}
        </div>
      )
      return <LayerPanelsExpansion titleid={titleid} panelTitle={PANEL_TITLE_REPORT} headerIcon={icon} markup={markup} licensed={this.isLicensed} />
    }

    icon = <IconReport htmlColor={ICON_COLOR_ENABLED} />
    markup = (
      <div className={classes.root}>
        <LayerReportPropSelect titleid={titleid} selectValues={this.selectValues} geojson={geojson} />
      </div>
    )
    return <LayerPanelsExpansion titleid={titleid} panelTitle={PANEL_TITLE_REPORT} headerIcon={icon} markup={markup} licensed={this.isLicensed} />
  }
}

Report.propTypes = {
  classes: PropTypes.object.isRequired,
  layer: PropTypes.object.isRequired,
  titleid: PropTypes.string.isRequired
}

function mapStateToProps (state, ownProps) {
  return {
    layer: state.layers[ownProps.titleid]
  }
}

const mapDispatchToProps = dispatch => {
  return {}
}

export default (
  withStyles(styles)(
    connect(
      mapStateToProps,
      mapDispatchToProps
    )(Report)
  )
)
